<template>
    <BaseModal id="loginModal" :show="show" center>
        <LogInPaper
            id="loginPaper"
            ref="loginPaper"
            v-on-clickaway="onClose"
            class="login-module-root extend-bottom-mobile"
            @close="onClose"
        />
    </BaseModal>
</template>

<script>
import LogInPaper from './components/LogInPaper';
import { mixin as clickaway } from 'vue-clickaway';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
    name: 'LogInModule',
    mixins: [clickaway],
    components: { LogInPaper },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        targetElement: null,
    }),
    mounted() {
        this.targetElement = document.getElementById('loginPaper');
    },
    methods: {
        onKey(event) {
            if (event.key === 'Escape') {
                this.onClose();
            }
        },
        onClose(event) {
            if (event) {
                if (event.state == 'backPressed') {
                    this.onClose();
                }
            } else {
                this.$interfaces.logInModule.toggleOpen();
            }
        },
    },
    watch: {
        show(shouldShow, wasShowing) {
            if (shouldShow) {
                // window.history.pushState('backPressed', null, null);
                // window.history.pushState('dummy', null, null);
                // window.addEventListener('popstate', this.onClose, {
                //     once: true,
                // });
                // Disabled escape to exit loginModule
                // document.addEventListener('keyup', this.onKey);
                this.$nextTick(() => disableBodyScroll(this.targetElement));
            } else {
                // document.removeEventListener('keyup', this.onKey);
                enableBodyScroll(this.targetElement);
            }
        },
    },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
    .login-module-root {
        margin-top: 0;
    }
}
</style>
